export const NOT_STARTED = 'notStarted'
export const PLAYING = 'playing'
export const PAUSED = 'paused'



// WEBPACK FOOTER //
// ./src/components/AudioPlayer/model/constants/PlayState.js